import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import SearchParamsBase from '../../../Elements/SearchParamsBase';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';

export default class FreelancerLineItemSearchParams extends SearchParamsBase {
  constructor(id) {
    super();
    if (id !== undefined) {
      this.FreelancerUserIdOrName = id.toString();
      this.OfficeId = [];
    }
  }

  initialize() {
    let yearsToAdd = 10;
    this.FreelancerLineItemId = '';
    this.FreelancerUserIdOrName = '';
    this.FeeType = '';
    this.OfficeId = OfficeHelper.GetDefaultOfficeIds(UserService.GetOfficeIdOfLoggedInUser());
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addYearsToNowDate(yearsToAdd * -1));
    this.EndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.FreelancerInvoiceId = '';
    this.Status = '';
    this.IsTimeBased = '';
    this.IsActive = '';
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'FreelancerLineItemId', label: 'Line Item Id', className: 'col-4', type: InputTypesEnum.Number },
    {
      fieldName: 'FreelancerUserIdOrName',
      label: 'Vendor (Id or Name)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'OfficeId',
      label: 'Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupSelect,
      roleKey: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: FreelancerLineItemSearchParams.getSelectValuesForStatus(),
    },
    { fieldName: 'FreelancerInvoiceId', label: 'InvoiceId', className: 'col-4', type: InputTypesEnum.Number },
    {
      fieldName: 'FeeType',
      label: 'Fee Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: FreelancerLineItemSearchParams.getSelectValuesForFeeType(),
    },
    { fieldName: 'UseDateRange', label: 'Use Date Range', className: 'col-3', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    { fieldName: 'IsTimeBased', label: 'Is TimeBased', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'IsActive', label: 'Is Active', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'FreelancerLineItemSearchParams';

  //---------------------------

  static getSelectValuesForFeeType() {
    return selectHelper.generateSelectValues([
      '',
      FeeTypesEnum.Resource,
      FeeTypesEnum.DataQuality,
      FeeTypesEnum.KAM,
      FeeTypesEnum.BD,
      FeeTypesEnum.BI,
      FeeTypesEnum.IT,
      FeeTypesEnum.HR,
      FeeTypesEnum.Marketing,
      FeeTypesEnum.Finance,
      FeeTypesEnum.FieldworkPartner,
    ]);
  }

  static getSelectValuesForStatus() {
    return selectHelper.generateSelectValues([
      '',
      'Deactivated',
      'WillBeInvoiced',
      'OnDraftInvoice',
      'OnFinalizedInvoice',
    ]);
  }
}
